/* istanbul ignore file */
export { default } from './QuoteForm';
